<div [hidden]="!active">
  <ng-content></ng-content>
</div>
